<template>
    <Head title="Ověření emailu"/>
    <jet-authentication-card>
        <template #logo>
            <jet-authentication-card-logo />
        </template>

        <div class="text-sm text-gray-600">
            Děkujeme za registraci! Předtím, než budete moci pokračovat, je potřeba ověřit Vaši emailovou adresu
        </div>
        <code class="block mx-2 text-sm font-bold text-center">
            {{user.email}}
        </code>
        <div class="mb-4 text-sm text-gray-600">
            kliknutím na odkaz ve zprávě, kterou jsme Vám poslali při registraci. Pokud jste zprávu neobdrželi, rádi pošleme novou!
        </div>

        <div class="mb-4 font-medium text-sm text-green-600" v-if="verificationLinkSent" >
            Byl Vám odeslán nový odkaz!
        </div>

        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-between">
                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Znovu odeslat odkaz
                </jet-button>

                <InertiaLink :href="route('logout')" method="post" as="button" class="underline text-sm text-gray-600 hover:text-gray-900">Odhlásit</InertiaLink>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
    import JetAuthenticationCard from '@/Layouts/AuthenticationCard'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
    import JetButton from '@/Jetstream/Button'
    import { Head, Link } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            InertiaLink: Link,
            Head
        },

        props: {
            status: String,
        },

        data() {
            return {
                user: this.$page.props.user,

                form: this.$inertia.form(),

                checkInterval: null,
            }
        },

        mounted(){
            this.setUpEcho();
        },
        unmounted(){
            this.destroyEcho();
        },

        methods: {
            submit() {
                this.form.post(this.route('verification.send'))
            },
            setUpEcho(){
                console.log('setup up echo email')
                Echo.private('App.Models.User.' + this.$page.props.user.id)
                    .listen('UserEmailVerifiedEvent', (e) => {
                        this.$inertia.get(route('app'));
                    });
            },
            destroyEcho(){
                console.log('destroy echo email')
                Echo.leave('App.Models.User.'+this.$page.props.user.id);
            },
        },

        computed: {
            verificationLinkSent() {
                return this.status === 'verification-link-sent';
            }
        }
    }
</script>
